export default __webpack_public_path__ + "static/banner_367-cd5602969913159d0b63d4ead8448b0c.jpg";